import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=2f671f6c&scoped=true"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"
import style0 from "./Affiliates.vue?vue&type=style&index=0&id=2f671f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f671f6c",
  null
  
)

export default component.exports